// extracted by mini-css-extract-plugin
module.exports = {"four-zoom-in":"FourZoomIn_four-zoom-in__2J1RJ","box":"FourZoomIn_box__2Jwem"};